/**
 * Created by moshemal on 6/13/16.
 */
define(['core/services/localization'], function (localization) {
  return localization;
});